<template>
  <div>
    <p class="titleModal">
      {{ $t('forms.labels.treatment') }}
    </p>
    <VTextField
      v-model="data.treatment"
      :label="$t('forms.labels.treatment')"
      :rules="{ required: true, min: 1, max: 200 }"
      outlined
      data-cy="cyArTreatment"
    />
    <VTextField
      v-model="data.otherTreatment"
      :label="$t('forms.labels.otherTreatment')"
      :rules="{ max: 1000 }"
      outlined
      data-cy="cyArOtherTreatment"
    />
    <VTextField
      v-model="data.estimatedDepositAge"
      outlined
      :label="$t('forms.labels.estimatedDepositAge')"
      :rules="{ required: true }"
      data-cy="cyArEstimatedDepositAgeDeposit"
    />
    <VTextField
      v-model="data.application"
      outlined
      :label="$t('forms.labels.application')"
      :rules="{ required: true, min: 1, max: 200 }"
      data-cy="cyArApplicationDeposit"
    />
    <VSelect
      v-model="data.materialType"
      outlined
      :label="$t('forms.labels.materialType')"
      itemValue="key"
      :items="materialTypes"
      :validateAtInitialization="!!data.materialType"
      :required="true"
      data-cy="cyArMaterialTypeDeposit"
    />
    <VSelect
      v-model="data.waterType"
      outlined
      :label="$t('forms.labels.waterType')"
      itemValue="key"
      :items="waterTypes"
      :validateAtInitialization="!!data.waterType"
      :required="true"
      data-cy="cyArWaterTypeDeposit"
    />
    <VTextarea
      v-model="data.incidents"
      outlined
      :label="$t('forms.labels.incidents')"
      :rules="{ min: 1, max: 1000 }"
      data-cy="cyArIncidentsDeposit"
    />
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';

import waterTypes from '@/constants/waterTypes';
import materialTypes from '@/constants/materialTypes';

export default {
    components: {
        VTextField,
        VTextarea,
        VSelect,
    },
    props: {
        analysisRequest: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            data: {
                treatment: this.analysisRequest.treatment,
                otherTreatment: this.analysisRequest.otherTreatment,
                estimatedDepositAge: this.analysisRequest.estimatedDepositAge,
                application: this.analysisRequest.application,
                materialType: this.analysisRequest.materialType,
                waterType: this.analysisRequest.waterType,
                incidents: this.analysisRequest.incidents,
            },
        };
    },
    computed: {
        waterTypes() {
            return waterTypes.map(type => ({
                name: this.$t(`waterTypes.${type}`),
                key: type,
            }));
        },
        materialTypes() {
            return materialTypes.map(type => ({
                name: this.$t(`materialTypes.${type}`),
                key: type,
            }));
        },
    },
    watch: {
        data: {
            handler() {
                this.$emit('updateData', this.data);
            },
            deep: true,
        },
    },
};
</script>
